import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import type { EditChannelBadge } from "./editChannel";

/** "my.echoflicks.com · Felix": where (and how) a post-delivery edit was asked (WRP-045). */
export function EditChannelChip({
  badge,
  className,
}: {
  badge: EditChannelBadge | null;
  className?: string;
}) {
  if (!badge) return null;
  return (
    <Badge
      variant="outline"
      title={badge.title}
      className={cn("px-1.5 py-0 text-[10px] font-normal", className)}
    >
      {badge.mode ? `${badge.label} · ${badge.mode}` : badge.label}
    </Badge>
  );
}
